import { Component, ViewChild, ElementRef } from '@angular/core';
import {
  IonicPage, NavController, NavParams,
  AlertController, Platform, ModalController
} from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { ConceptosEgresosProvider  } from '../../providers/conceptos-egresos/conceptos-egresos'
import { LoadingController } from 'ionic-angular';
import { CompaniasProvider } from '../../providers/companias/companias'
import { AuthService } from '../../providers/auth-service'
import { MODO_DESCONECTADO,NUBE_AWS,RUTA_MODO_DESCONECTADO } from '../../config/url.servicio'
import { ElectronService } from 'ngx-electron';
import { UtilsProvider } from '../../providers/utils/utils'

@IonicPage()
@Component({
  selector: 'page-conceptos-egresos',
  templateUrl: 'conceptos-egresos.html',
  providers: [ AuthService,ElectronService ]
})
export class ConceptosEgresosPage {

  conceptosEgresos = []
  codigo: String = ''
  nombre: String = ''
  conceptosEgresosId: number = 0

  editarConceptoEgreso: boolean = false
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  companiasId:any = null
  modo:boolean = MODO_DESCONECTADO === undefined ? true : MODO_DESCONECTADO
  tipo
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public alertControllers: AlertController,
    public platforms: Platform,
    public modalControllers: ModalController,
    public servicio: ConceptosEgresosProvider,
    private storage: Storage,
    public loadingCtrl: LoadingController ,
    public servicioCompania:CompaniasProvider,
    public auth: AuthService,
    public util: UtilsProvider,
    private _electronService: ElectronService
  ) {
      this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId'])
      .then((val)=>{
        if(val){
          this.nombreCompaniaHeader = val['nombreCompania']
          this.nombreCargoHeader = val['nombreCargo']
          var valor = val['companiasId']
          this.companiasId = valor
          this.cargarConceptosEgresos()

        }
      })

  }

  cargarConceptosEgresos() {
    this.conceptosEgresos = []

    this.servicio.buscarConceptosEgresosPorEmpresa(this.companiasId)
    .subscribe(
      res => {
        if(NUBE_AWS){
          this.conceptosEgresos =  JSON.parse(res['_body']).data[0] === undefined ? [] : JSON.parse(res['_body']).data[0]
        } else {
          this.conceptosEgresos = res
        }
      },
      err => {
        this.util.mensajeMuestro('Conceptos Egresos','No se pudieron listar los conceptos egresos, intente luego','warning')
      }
    )
  }

  guardar() {

    if (this.codigo===''){
      this.util.mensajeMuestro('Conceptos Egresos','Debe Ingresar un código','warning')
      return
    }

    if (this.nombre===''){
      this.util.mensajeMuestro('Conceptos Egresos','Debe Ingresar el nombre','warning')
      return
    }
    let datosConceptoEgreso: any = {}
    if(!this.editarConceptoEgreso) {
      datosConceptoEgreso = {
        codigo: this.codigo,
        nombre: this.nombre,
        tipo: this.tipo,
        queHago: "I",
        nombreTabla: "conceptosEgresos",
        name: "dataDynamicCrud"
      }
    } else {
      datosConceptoEgreso = {
        codigo: this.codigo,
        nombre: this.nombre,
        tipo: this.tipo,
        conceptosEgresosId : this.conceptosEgresosId,
        queHago: "A",
        nombreTabla: "conceptosEgresos",
        name: "dataDynamicCrud"
      }
    }


    this.storage.get('companiasId').then((val) => {
      datosConceptoEgreso['companiasId'] = val

      if(this.editarConceptoEgreso){
        this.editarConceptoEgreso = false;
      }

      this.guardarConceptoEgreso(datosConceptoEgreso)

    });
  }

  guardarConceptoEgreso(datosConceptoEgreso){
    this.servicio.guardar(datosConceptoEgreso)
    .subscribe(
      res => {
        this.util.mensajeMuestro('Conceptos Egresos','El concepto ha sido guardado con éxito!','success')
        this.procesarResultado()
      },
      err => this.util.mensajeMuestro('Coneptos Egresos','No se pudo guardar el producto, intente luego','warning')
    )
  }

  limpiar() {
    this.codigo = ""
    this.nombre = ""
    this.conceptosEgresosId = 0
  }

  editar(item){
    this.codigo = item.codigo
    this.nombre = item.nombre
    this.conceptosEgresosId = item.conceptosEgresosId
    this.editarConceptoEgreso = true
  }

  eliminar(todo: any) {
    this.util.mensajeConfirmacion('Conceptos Egresos','¿Está Seguro de borrar el registro?','warning',["Cancelar","Aceptar"],false)
     .then((loQuiereBorrar: boolean) => {
      if (loQuiereBorrar) {
        let conceptoElimino = []
        conceptoElimino['queHago'] = "E"
        conceptoElimino['name'] = "dataDynamicCrud"
        conceptoElimino['nombreTabla'] = "conceptosEgresos"
        conceptoElimino['conceptosEgresosId'] = todo.conceptosEgresosId
        this.servicio.eliminar(conceptoElimino)
        .subscribe(
          res => {
            this.util.mensajeMuestro('Conceptos Egresos','Eliminado Exitosamente','success')
            this.procesarResultado()
          },
          err => console.log(err)
        )
      }
      else {
        this.util.mensajeMuestro('Conceptos Egresosrgos','No se eliminó el registro','warning')
        this.procesarResultado()
      }
    })
  }

  procesarResultado() {
    this.limpiar()
    this.cargarConceptosEgresos()
  }

  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/conceptos-egresos/conceptos-egresos.ts